import { useEffect, useState } from 'react';
import { readAdminSessionUser } from '../utils/settingsSessionUser';

/** Même source que le header Layout : localStorage admin_user, resynchronisé. */
export function useAdminSessionUser() {
  const [user, setUser] = useState(() => readAdminSessionUser());

  useEffect(() => {
    const sync = () => setUser(readAdminSessionUser());
    const onStorage = (e) => {
      if (!e.key || e.key === 'admin_user') sync();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('authUserUpdated', sync);
    const interval = setInterval(sync, 2000);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('authUserUpdated', sync);
      clearInterval(interval);
    };
  }, []);

  return user;
}
